import fetch from '../../../core/fetch';
import history from '../../../core/history';
import showToaster from '../../../helpers/showToaster';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

const isContentEmpty = (content = '') => {
  const stripped = content.replace(/<(.|\n)*?>/g, '').trim();
  return !content || stripped.length === 0 || content === '<p><br></p>' || content === '<p> </p>';
};

async function submit(values, dispatch) {
  const isRestrict = await dispatch(demoRestriction({}));
  if (isRestrict) return;

  if (isContentEmpty(values.content)) {
    showToaster({ messageId: 'addContent', toasterType: 'error' });
    return;
  }

  const mutation = `
    mutation updateBlogDetails(
      $id: Int,
      $metaTitle: String,
      $metaDescription: String,
      $pageUrl: String,
      $pageTitle: String,
      $content: String,
      $footerCategory: String
    ) {
      updateBlogDetails(
        id: $id,
        metaTitle: $metaTitle,
        metaDescription: $metaDescription,
        pageUrl: $pageUrl,
        pageTitle: $pageTitle,
        content: $content,
        footerCategory: $footerCategory
      ) {
        status
      }
    }
  `;

  try {
    const response = await fetch('/graphql', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify({ query: mutation, variables: values })
    });

    const { data } = await response.json();

    switch (data?.updateBlogDetails?.status) {
      case 'success':
        showToaster({ messageId: 'updateBlogDetails', toasterType: 'success' });
        history.push('/siteadmin/content-management');
        break;
      case 'URL exist':
        showToaster({ messageId: 'invalidUrl', toasterType: 'error' });
        break;
      default:
        showToaster({ messageId: 'updateLocationError', toasterType: 'error' });
    }

  } catch (error) {
    console.error('Submit error:', error);
    showToaster({ messageId: 'updateLocationError', toasterType: 'error' });
  }
}

export default submit;